import { findAncestorWithComponent } from "../utils/scene-graph";
AFRAME.registerComponent("link-sequence", {
  schema: {
    uuid: { type: "string" },
    linkedModel: { type: "array"},
    disposeAnimation: { type: "array"}
  },
  init(){
    this.mixerEl = findAncestorWithComponent(this.el, "animation-mixer");
    this.treshold = 0.2;
  },
  tick(now) {
    // Throttle to 5fps
    if (now - this.lastTick < 200) return;
    this.lastTick = now;

    const scene = this.el.sceneEl;
    if (!scene.is("entered")) return;

    this.checkLinkedAnimationLoop();

  },
  checkLinkedAnimationLoop(){
    const enableProximity = this.el.components['enable-on-proximity'];
    const loopAnimation = this.el.components['loop-animation'];
    
    if(!enableProximity || !enableProximity.enabled ){ 
      return;
    }
    if(!loopAnimation) {
      return;
    }
    const [currentAction] = loopAnimation.currentActions;
    // Actions may not exist yet while the proximity animation is initializing.
    if (!currentAction) return;
    if((currentAction.time + this.treshold) >= currentAction._clip.duration) {
      this.showLinkedModel();
    }
  },
  findLinkedModels(loops, loopNear){
    let nextLoops = [];
    loops.forEach(loop => {
      if(loopNear.components['link-sequence'].data.linkedModel.includes(
        loop.components['link-sequence'].data.uuid
      )) {
        
        nextLoops.push(loop);
      }
    });
    return nextLoops;
  },
  findModelsDispose(loops, loopNear){
    let nextLoopsDispose = [];
    
    loops.forEach(loop => {
      if(loopNear.components['link-sequence'].data.disposeAnimation.includes(
        loop.components['link-sequence'].data.uuid
      )) {
        
        nextLoopsDispose.push(loop);
      }
    });
    return nextLoopsDispose;
  },
  showLinkedModel() {
    const loops = document.querySelectorAll('[link-sequence]');
    // A-Frame marks every attached entity as attachedToParent. Authored children
    // must use their own finish targets, even when the parent has a sequence.
    const loopNear = this.el;

    const nextLoops = this.findLinkedModels(loops, loopNear);
    if(Array.isArray(this.attrValue.disposeAnimation)) {
      const nextLoopsDispose = this.findModelsDispose(loops, loopNear);
      nextLoopsDispose.forEach(loop => {
        loop.remove();
      })
    } else if(this.attrValue.disposeAnimation === true) {
      loopNear.remove();
    }
    
    if(!nextLoops || nextLoops.length == 0) {
      return;
    }
    nextLoops.forEach(nextLoop => {
      nextLoop.removeAttribute('visible');
      nextLoop.object3D.visible = true;
    })
  },
  checkVideo(currentTime, duration) {
    if((currentTime + this.treshold) >= duration) {
      this.showLinkedModel();
    }
  }
});
